import { createReducer } from '../../app/common/util/reducerUtil';
import { 
    APPLY_PROMO_CODE,
    APPLY_FREE_FUND_CODE,
    GET_BALANCE,
    NET_BANKING_OPTIONS,
    RESET_PROMO_CODE,
    RESET_FREE_FUND_CODE,
    VALIDATE_PROMO_CODE,
    TOGGLE_FREEFUND_CODE,
    TOGGLE_PROMO_CODE,
    GET_WITHDRAW_FEE,
    DELETE_WITHDRAW_FEE,
    SELECT_BANK_ACCOUNT,
    WITHDRAW_SUCCESS,
    CARD_BINS
} from './PaymentConstants';

const initialState = {};

export const toggleFreefundCodeForm = (state) => {
  return {
    ...state,
    showFreefundCode: (state && state.showFreefundCode) ? false : true,
  }
}

export const togglePromoCodeForm = (state) => {
  return {
    ...state,
    showPromoCode:  (state && state.showPromoCode) ? false : true,
  }
}

export const getBalance = (state, payload) => {
  return {
    ...state,
    balance: payload,
  };
};

export const netBankingOptions = (state, payload) => {
  return {
    ...state,
    netBanking: payload,
  }
}

export const applyPromoCode = (state, payload) => {
  return {
    ...state,
    promoCode: payload,
  };
};

export const validatePromoCode = (state, payload) => {
  return {
    ...state,
    promovalid: payload,
  };
};

export const applyFreeFundCode = (state, payload) => {
  return {
    ...state,
    freefundcode: payload,
  };
};

export const resetPromoCode = (state, payload) => {
  return {
    ...state,
    promoCode: payload
  }
}

export const resetFreeFundCode = (state, payload) => {
  return {
    ...state,
    freefundcode: payload
  }
}

export const getWithdrawFeeDetails = (state, payload) => {
  return {
    ...state,
    withdrawfees: payload
  }
}

export const deleteWithdrawFee = (state) => {
  delete state.withdrawfees;
  return state;
}

export const selectBankAccount = (state, payload) => {
  return {
    ...state,
    selectedBankAccount: payload,
  }
}

export const withdrawSuccess = (state) => {
  return {
    ...state,
    withdrawSuccess: true,
  }
}

export const cardBins = (state, payload) => {
  return {
    ...state,
    cardBins: payload,
  }
}

export default createReducer(initialState, {
  [GET_BALANCE]: getBalance,
  [NET_BANKING_OPTIONS]: netBankingOptions,
  [APPLY_PROMO_CODE]: applyPromoCode,
  [VALIDATE_PROMO_CODE]: validatePromoCode,
  [APPLY_FREE_FUND_CODE]: applyFreeFundCode,
  [RESET_PROMO_CODE]: resetPromoCode,
  [RESET_FREE_FUND_CODE]: resetFreeFundCode,
  [TOGGLE_FREEFUND_CODE]: toggleFreefundCodeForm,
  [TOGGLE_PROMO_CODE]: togglePromoCodeForm,
  [GET_WITHDRAW_FEE]: getWithdrawFeeDetails,
  [DELETE_WITHDRAW_FEE]: deleteWithdrawFee,
  [SELECT_BANK_ACCOUNT]: selectBankAccount,
  [WITHDRAW_SUCCESS]: withdrawSuccess,
  [CARD_BINS]: cardBins
});